import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import ValidatedTextField from 'components/Common/ValidatedTextField';
import { Form, Formik } from 'formik';
import { closeAllModals, openModal } from 'reducers/modalReducer';
import partnerService from 'services/partnerService';
import { PartnerType } from 'types/Partner';

const GDPRModal = ({ partnerType, techId }: { partnerType: PartnerType; techId: string }) => {
  const dispatch = useDispatch();
  const [downloading, setDownloading] = useState(false);

  return (
    <Dialog
      open={true}
      id="gdpr-dialog"
      aria-labelledby="gdpr-dialog-title"
      maxWidth="xl"
      onClose={() => dispatch(closeAllModals())}
    >
      <DialogTitle id="gdpr-dialog-title">
        <Typography variant="h4">GDPR Data Request</Typography>
      </DialogTitle>

      <Formik
        onSubmit={() => {}}
        initialValues={{
          caseId: '',
        }}
      >
        {({ values }) => {
          return (
            <Form>
              <DialogContent style={{ minWidth: '30%' }}>
                <div style={{ width: '300px' }}>
                  <ValidatedTextField
                    label="Please enter case ID"
                    disabled={downloading}
                    test-id="caseId-text-input"
                    placeholder=""
                    name="caseId"
                    maxChar={250}
                  />
                </div>
              </DialogContent>
              <DialogActions style={{ padding: '5%' }}>
                <Button onClick={() => dispatch(closeAllModals())} autoFocus color="primary" id="gdpr-cancel-button">
                  Cancel
                </Button>
                <Button
                  disabled={downloading || !values.caseId}
                  color="primary"
                  onClick={() => {
                    setDownloading(true);
                    partnerService.getGdprData(values.caseId, techId, partnerType).then(
                      (response) => {
                        const type = response.headers['content-type'] as string | undefined;
                        const blob = new Blob([response.data], {
                          type: type,
                        });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `GDPR-data-${techId}.json`;
                        link.click();
                        setDownloading(false);
                        dispatch(closeAllModals());
                      },
                      function (error) {
                        dispatch(
                          openModal({
                            modalType: 'JBErrorModalWrapper',
                            modalProps: {
                              technicalInfo: {
                                details: 'Error fetching gdpr data from partner-data-mgmt',
                                title: 'Error fetching gdpr data',
                                userErrorMessage: 'An error occurred when fetching gdpr data',
                              },
                              httpError: error,
                            },
                          }),
                        );
                      },
                    );
                  }}
                  variant="contained"
                  id="gdpr-generate-button"
                >
                  {downloading ? (
                    <>
                      Generating.. <CircularProgress size={20} />
                    </>
                  ) : (
                    <>Generate</>
                  )}
                </Button>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default GDPRModal;
